import './FuturePlans.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faShop } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faHammer } from '@fortawesome/free-solid-svg-icons';

const goals = [
  {
    icon: faHandshake,
    title: "Strategic Partnerships",
    text: "Partnering with strategic groups that offer unique strengths and deep domain expertise."
  },
  {
    icon: faGlobe,
    title: "Premium Locations",
    text: "Securing access to premium, high-traffic locations across key global markets."
  },
  {
    icon: faShop,
    title: "Emerging Markets",
    text: "Developing expertise in high-potential or emerging markets with scalable opportunity."
  },
  {
    icon: faEye,
    title: "Operational Vision",
    text: "Pioneering operational models that align with Solid Investment's long-term vision."
  },
  {
    icon: faHammer,
    title: "New Frontiers",
    text: "Exploring innovative opportunities in new markets to build on our portfolio's strengths and scalability."
  }
];

function FuturePlans() {
  return (
    <div className="future-plans">
      <div className="future-plans-container">
        <h1>Future Goals & Partnerships</h1>
        <p className="future-plans-subtitle">Strategic Direction</p>
        <p className="future-plans-subtext">
          Our mission is to strategically invest in innovative concepts, nurture their growth,
          and position them for global success by leveraging market expertise, operational excellence,
          and collaborative partnerships.
        </p>
        <div className="future-plans-list">
          {goals.map((goal, index) => (
            <div className="future-plan" key={index}>
              <div className="future-plan-icon-wrapper">
                <FontAwesomeIcon icon={goal.icon} className="future-icon" />
              </div>
              <h3>{goal.title}</h3>
              <p>{goal.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FuturePlans;
